import { fetch } from './fetch';

export const fetchReports = fetch('FETCH_REPORTS', 'gt/customer/reports/');
export const confirmReport = fetch('CONFIRM_REPORT', 'gt/customer/confirm_report/', {
    method: 'POST',
});
